import React from 'reactn';
import styles from './index.style';
import {
  Dialog,
  Grid,
  Box,
  Typography,
  IconButton,
  DialogContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  List,
  ListItem,
  ListItemText,
  Divider,
  Button,
  Chip,
  DialogActions,
  Fade,
  Grow,
  CircularProgress,
  ClickAwayListener,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/styles';
import ConfirmationModal from '../confirmation-modal';
import ResponseBox from '../response-box';
import { USER_CONTEXT } from '../../constants';
import { isPermitted } from '../permission-control/permission-control';
import {
  qrylocation,
  manageMessagingRelationship,
  getAvailableRelationships,
  fetchSearchLearner,
} from '../../util/APIUtils';
import { withUnleashClient } from '../../v2/core/unleash';
import { UnleashService } from '../../v2/services';
import { UserIcon } from '../UserIcon';
import { VerifiedUserIcon } from '../../v2/shared/components/MaterialUIIcons';
import { Loader } from '@orijinworks/frontend-commons';

export class LinkUser extends React.Component {
  MANAGE_TYPE = {
    ADD: 0,
    REMOVE: 1,
    CLEAR: 2,
  };
  debounceRef = null;
  initialSearchKey = '%25';
  constructor(props) {
    super(props);
    this.state = {
      responseBoxData: [],
      isLinkDialogOpen: this.props.isOpen || false,
      isConfirmOpen: false,
      isResponseBoxOpen: false,
      suggestedUsers: [],
      availableRelationps: [],
      selectedUsers: [],
      selectedLocation: this.getSelectedLocation(),
      housingUnits: {
        selected: '',
        collection: [],
      },
      isBoxHidden: false,
      v2Relationship: false,
      isLoading: false,
    };
  }

  componentDidMount() {
    const unleashClient = this.props.unleashClient();
    this.setState({
      v2Relationship: unleashClient.isEnabled(UnleashService.FLAGS.V2_RELATIONSHIP),
    });
  }

  componentDidUpdate() {
    if (this.props.isOpen !== this.state.isLinkDialogOpen) {
      const selectedLocation = this.getSelectedLocation();
      this.setState({ selectedLocation });
      this.toggleFlag(this.props.isOpen, 'isLinkDialogOpen');
    }
  }

  /**
   * @name getSelectedLocation
   * @desc Gets selected location based upon certain conditions
   * @return {void}
   */
  getSelectedLocation = () => {
    const location = (this.props.locations || []).filter((location) => location.active);
    return location.length > 0 ? location[0] : {};
  };

  /**
   * @name locationChangeHandler
   * @param {object} location
   * @desc Performs all location change handler related items
   * @return {void}
   */
  locationChangeHandler = (location) => {
    this.setState({
      selectedLocation: location,
    });
    if (this.state.v2Relationship) {
      this.filterSuggestedUsers(this.state.searchValue);
    } else {
      this.getSuggestedUser(this.props.userInfo.userId, location);
    }
  };

  /**
   * @name manageUser
   * @param {string} type Type of operation.
   * @param {object} user User data
   * @param {number} index User index in list.
   * @desc Manage's user add / remove flow.
   * @return {void}
   */
  manageUser = (type, user, index) => {
    let { selectedUsers, suggestedUsers } = this.state;
    switch (type) {
      case this.MANAGE_TYPE.ADD:
        selectedUsers.push({
          ...user,
          ...this.state.selectedLocation,
        });
        break;
      case this.MANAGE_TYPE.REMOVE:
        selectedUsers.splice(index, 1);
        suggestedUsers.push(user);
        break;
      case this.MANAGE_TYPE.CLEAR:
        suggestedUsers = [];
        selectedUsers = [];
        break;
      default:
        console.log('No case found!!');
    }
    this.setState({
      selectedUsers: selectedUsers || [],
      suggestedUsers: suggestedUsers || [],
    });
  };

  /**
   * @name toggleFlag
   * @param {boolean} value
   * @param {string} keyName
   * @desc Toggles flag based upon invoking method.
   * @return {void}
   */
  toggleFlag = (value, keyName) => {
    this.setState({
      [keyName]: value,
    });
  };
  /**
   * @name getSuggestedUserV2
   * @param {number} userId User ID whose relationship needs to be fetched.
   * @param {object} location Location payload object
   * @param {string} searchValue Search value
   * @desc Fethces available relation w.r.t user.
   * @return {void}
   */
  getSuggestedUserV2 = (userId, location) => {
    const { searchValue } = this.state;
    const loggedinUser = USER_CONTEXT || {};
    this.setGlobal({
      isLoading: true,
    });
    getAvailableRelationships(userId, location.locationId, searchValue).then(
      (_successLog) => {
        _successLog = _successLog.sort((a, b) => a.contactUsername.localeCompare(b.contactUsername));
        const editPermission = isPermitted(
          this.global.cbacConfigFlag,
          this.global.permissions,
          'Edit_All_Relationships_At_Facility'
        );
        const personalPermission = isPermitted(
          this.global.cbacConfigFlag,
          this.global.permissions,
          'Create_Personal_Relationships'
        );
        if (!editPermission && personalPermission) {
          let selectedUsers = _successLog.filter((user) => user.contactId == loggedinUser.personId);
          if (selectedUsers.length > 0) {
            this.manageUser(this.MANAGE_TYPE.CLEAR);
            this.manageUser(this.MANAGE_TYPE.ADD, selectedUsers[0], 0);
            this.setState({
              suggestedUsers: _successLog,
              isBoxHidden: true,
              isLoading: false,
            });
          } else if (selectedUsers.length === 0) {
            this.setState({
              isBoxHidden: true,
              isLoading: false,
            });
          }
        } else {
          this.setState({
            suggestedUsers: _successLog,
            isBoxHidden: false,
            isLoading: false,
          });
        }
        this.setGlobal({
          isLoading: false,
        });
      },
      (_errorLog) => {
        this.setGlobal({
          isLoading: false,
        });
      }
    );
  };

  /**
   * @name getSuggestedUser
   * @param {number} userId User ID whose relationship needs to be fetched.
   * @param {object} location Location payload object
   * @desc Fethces available relation w.r.t user.
   * @return {void}
   */
  getSuggestedUser = (userId, location) => {
    this.setGlobal({
      isLoading: true,
    });
    this.setState({
      availableRelations: [],
      suggestedUsers: [],
      searchValue: '',
    });
    getAvailableRelationships(userId, location.locationId).then(
      (_successLog) => {
        const editPermission = isPermitted(
          this.global.cbacConfigFlag,
          this.global.permissions,
          'Edit_All_Relationships_At_Facility'
        );
        const personalPermission = isPermitted(
          this.global.cbacConfigFlag,
          this.global.permissions,
          'Create_Personal_Relationships'
        );
        const loggedinUser = USER_CONTEXT || {};
        this.processRelationshipsData(_successLog).then((response) => {
          if (!editPermission && personalPermission) {
            let selectedUsers = response.filter((user) => user.contactId == loggedinUser.personId);
            if (selectedUsers.length > 0) {
              this.manageUser(this.MANAGE_TYPE.CLEAR);
              this.manageUser(this.MANAGE_TYPE.ADD, selectedUsers[0], 0);
              this.setState({
                availableRelationps: selectedUsers,
                isBoxHidden: true,
              });
            } else if (selectedUsers.length === 0) {
              this.setState({
                isBoxHidden: true,
              });
            }
          } else {
            this.setState({
              availableRelationps: response,
              isBoxHidden: false,
            });
          }
        });

        this.setGlobal({
          isLoading: false,
        });
      },
      (_errorLog) => {
        this.setGlobal({
          isLoading: false,
        });
      }
    );
  };

  processRelationshipsData = async (data) => {
    let relationships = [data || []].filter((item, index, self) => {
      return self.findIndex((value) => value.contactId === item.contactId) === index;
    });
    relationships = relationships.map((item) => {
      const filtered = [data || []].filter((value) => value.contactId === item.contactId);
      const roles = filtered.map((a) => a.role);
      const locations = filtered.map((a) => a.locationName);
      return {
        ...item,
        role: [...new Set(roles)].join(', '),
        locationName: [...new Set(locations)].join(', '),
      };
    });

    const relationshipUsers = await fetchSearchLearner(this.initialSearchKey, this.state.selectedLocation.locationId);

    for (const key in relationships[0]) {
      if (relationshipUsers.find((item) => item.contactId === relationships[0][key].contactId)) {
        delete relationships[0][key];
      }
    }

    return relationships;
  };

  getIcon = (roleName) => {
    switch (roleName) {
      case 'Attorney':
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xlink="http://www.w3.org/1999/xlink"
            svgjs="http://svgjs.com/svgjs"
            version="1.1"
            width="25px"
            height="25px"
            x="0"
            y="0"
            viewBox="0 0 480.004 480.004"
            space="preserve"
            class=""
          >
            <g>
              <g xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path
                    d="M479.202,292.692l0.072-0.024l-78.808-171.952l19.112-9.512l-7.152-14.32l-18.632,9.28l-2.52-5.496    c-1.842-4.016-6.59-5.779-10.606-3.938c-1.742,0.799-3.139,2.196-3.938,3.938l-2.248,4.912c-13.56-6.298-28.329-9.566-43.28-9.576    h-67.2v-16h16v-16H266.25l5.752-23.016c4.416-17.673-6.33-35.58-24.003-39.997c-17.673-4.416-35.58,6.33-39.997,24.003    c-1.312,5.25-1.312,10.743,0,15.993l5.752,23.016h-13.752v16h16v16h-67.16c-14.966,0.012-29.75,3.288-43.32,9.6l-2.248-4.912    c-1.841-4.016-6.59-5.779-10.606-3.938c-1.742,0.799-3.139,2.196-3.938,3.938l-2.52,5.496l-18.632-9.32l-7.152,14.336    l19.112,9.552L0.73,292.668c-0.486,1.045-0.734,2.184-0.728,3.336c0.035,30.913,25.087,55.965,56,56h80    c30.913-0.035,55.965-25.087,56-56c-0.02-1.149-0.293-2.28-0.8-3.312l-79.024-172.6c11.487-5.332,24-8.092,36.664-8.088h67.16    v292.688l-27.312,27.312h-28.688c-22.08,0.026-39.974,17.92-40,40c0,4.418,3.582,8,8,8h224c4.418,0,8-3.582,8-8    c-0.026-22.08-17.92-39.974-40-40h-28.688l-27.312-27.312V112.004h67.2c12.664-0.004,25.177,2.756,36.664,8.088L288.73,292.668    c-0.486,1.045-0.734,2.184-0.728,3.336c0.035,30.913,25.087,55.965,56,56h80c30.913-0.035,55.965-25.087,56-56    C479.983,294.855,479.71,293.724,479.202,292.692z M136.002,336.004h-80c-19.002-0.021-35.375-13.387-39.2-32h158.4    C171.378,322.617,155.004,335.983,136.002,336.004z M171.538,288.004H20.466l73.488-160.328c1.342,0.36,2.754,0.36,4.096,0    L171.538,288.004z M226.618,22.532c6.23-7.392,17.273-8.333,24.665-2.103c0.759,0.64,1.463,1.344,2.103,2.103    c3.236,4.116,4.379,9.5,3.096,14.576l-6.728,26.896H230.25l-6.728-26.896C222.239,32.032,223.383,26.648,226.618,22.532z     M232.002,96.004v-16h16v16H232.002z M248.002,112.004v288h-16v-288H248.002z M320.002,448.004    c10.168,0.012,19.229,6.418,22.632,16H137.37c3.403-9.582,12.464-15.988,22.632-16H320.002z M268.69,432.004h-57.376l16-16h25.376    L268.69,432.004z M381.938,127.7c1.321,0.465,2.77,0.405,4.048-0.168l73.552,160.472H308.466L381.938,127.7z M424.002,336.004h-80    c-19.002-0.021-35.375-13.387-39.2-32h158.4C459.378,322.617,443.004,335.983,424.002,336.004z"
                    fill="#061E44"
                    data-original="#000000"
                  />
                </g>
              </g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
              <g xmlns="http://www.w3.org/2000/svg"></g>
            </g>
          </svg>
        );

      default:
        return <VerifiedUserIcon />;
    }
  };

  /**
   * @name filterSuggestedUsers
   * @param {string} searchTerm
   * @desc Filters suggested users from available relationships.
   * @return {void}
   */
  filterSuggestedUsers = (searchTerm = '') => {
    searchTerm = searchTerm.toString().toLowerCase();
    if (this.state.v2Relationship) {
      this.setState({
        searchValue: searchTerm,
        suggestedUsers: [],
        isLoading: searchTerm !== '',
      });
      if (this.debounceRef) {
        clearTimeout(this.debounceRef);
      }
      this.debounceRef = setTimeout(() => {
        if (searchTerm !== '') {
          this.getSuggestedUserV2(this.props.userInfo.userId, this.state.selectedLocation);
        }
      }, 2000);
      return;
    }
    const { availableRelationps, selectedUsers } = this.state;
    if (availableRelationps && availableRelationps.length) {
      const allRelationships = availableRelationps[0];
      let suggestedUsers = [];

      for (const key in allRelationships) {
        if (
          (allRelationships[key].contactName || '').toLowerCase().indexOf(searchTerm) > -1 ||
          (allRelationships[key].contactUsername || '').toLowerCase().indexOf(searchTerm) > -1
        ) {
          suggestedUsers.push(allRelationships[key]);
        }
      }
      suggestedUsers = (suggestedUsers || []).filter((user) => {
        return !selectedUsers.find((_selectedUser) => _selectedUser.contactId === user.contactId);
      });

      this.setState({
        suggestedUsers,
        searchValue: searchTerm,
      });
    }
  };

  getFullName = (items, personId, keyName, returnKeyName) => {
    const item = items.find((data) => data[keyName] == personId);
    return item[returnKeyName];
  };

  /**
   * @name onConfirm
   * @desc Fire's when confirmation box is accepted.
   * @return {void}
   */
  onConfirm = () => {
    const requestPayload = {
      msgRelationships: this.state.selectedUsers.map((selectedItem) => ({
        firstPersonKey: parseInt(selectedItem.contactId),
        secondPersonKey: parseInt(this.props.userInfo.userId),
        status: true,
      })),
    };
    this.setGlobal({
      isLoading: true,
    });
    manageMessagingRelationship(requestPayload).then(
      (_successLog) => {
        const responseData = [];
        _successLog.successList.forEach(({ statusCode, firstPersonKey, secondPersonKey }) => {
          responseData.push({
            statusCode: statusCode,
            text: `Relationship between ${this.getFullName(
              this.state.selectedUsers,
              firstPersonKey,
              'contactId',
              'contactName'
            )} & ${this.props.userInfo.displayName} created.`,
          });
        });
        _successLog.errorList.forEach((_errorNodes) => {
          responseData.push({
            statusCode: _errorNodes.statusCode,
            text: `${_errorNodes.statusMessage}.`,
          });
        });
        this.setGlobal({
          isLoading: false,
        });

        this.setState(
          {
            responseBoxData: responseData,
            suggestedUsers: [],
            selectedUsers: [],
          },
          () => {
            this.toggleFlag(false, 'isConfirmOpen');
            this.toggleFlag(true, 'isResponseBoxOpen');
          }
        );
        if (this.props.getRelationships) {
          this.props.getRelationships();
        }
      },
      (_errorLog) => {
        this.setGlobal({
          isLoading: false,
        });
        this.manageUser(this.MANAGE_TYPE.CLEAR);
        this.setState(
          {
            responseBoxData: [
              {
                statusCode: 400,
                text: `Something went wrong.`,
              },
            ],
          },
          () => {
            this.toggleFlag(false, 'isConfirmOpen');
            this.toggleFlag(true, 'isResponseBoxOpen');
          }
        );
      }
    );
  };

  /**
   * @name userRole
   * @desc Return's role of user with which relationship is being created otherwise returns "staff"
   * @return {string}
   */
  get userRole() {
    if (this.props.userInfo.role) {
      return this.props.userInfo.role.toLowerCase();
    }
    return 'staff';
  }

  onDialogClose = () => {
    this.toggleFlag(false, 'isLinkDialogOpen');
    this.setState({ selectedUsers: [] });
    this.props.onClose();
  };

  StaffMenuItem = ({ user, index, classes }) => (
    <>
      <Box className={classes.blueIconContainer} component={'span'}>
        {this.getIcon(user.role)}
      </Box>
      <ListItemText id={`${user.contactUsername}-list-item`} primary={user.contactUsername} />
    </>
  );
  LearnerMenuItem = ({ user }) => {
    let learnerName = user.contactUsername;
    if (user.docId) {
      learnerName += ` | ${user.docId}`;
    }
    return <ListItemText id={`${user.contactUsername}-list-item`} primary={learnerName} />;
  };

  handleClickAway = () => {
    this.setState({
      searchValue: '',
      responseBoxData: [],
      suggestedUsers: [],
    });
  };
  LinkingDialog = () => {
    const { classes } = this.props;
    const { selectedUsers, isLoading, v2Relationship } = this.state;
    const filterSuggestedUser = v2Relationship
      ? this.state.suggestedUsers.filter(
          (user) => !Boolean(selectedUsers.find((selectedUser) => selectedUser.contactId === user.contactId))
        )
      : [];
    return (
      <Dialog
        open={this.state.isLinkDialogOpen}
        classes={{
          paper: classes.dialog,
        }}
        onClose={this.onDialogClose}
      >
        <Grid container justify="space-between" alignItems="center" className={classes.head}>
          <Box display="flex" justifyContent="space-between" alignItems="center" className={classes.headLeft}>
            <Typography className={classes.headHeading} variant="h6">
              Link Learner
            </Typography>
            <IconButton onClick={this.onDialogClose} className={classes.closeBtn}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Grid>
        <DialogContent>
          <Grid container item className={classes.formGroup}>
            <Grid item md={12}>
              <FormControl className={classes.formControl} variant="outlined">
                <InputLabel>Location</InputLabel>
                <Select
                  value={this.state.selectedLocation}
                  onChange={(event) => this.locationChangeHandler(event.target.value)}
                  label="Location"
                  id="location-select"
                >
                  <MenuItem value={''}>
                    <em>None</em>
                  </MenuItem>
                  {(this.props.locations || [])
                    .filter((location) => location.active)
                    .map((location) => (
                      <MenuItem value={location}>{location.locationName}</MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <ClickAwayListener onClickAway={this.handleClickAway}>
            <Grid container item className={classes.formGroup}>
              <Grid item md={12}>
                {!this.state.isBoxHidden && (
                  <>
                    <TextField
                      id="user-textfield"
                      autoFocus
                      className={classes.formControl}
                      label="Search User"
                      disabled={this.state.isBoxHidden}
                      onChange={(event) => this.filterSuggestedUsers(event.target.value)}
                      variant="outlined"
                      value={this.state.searchValue}
                    />
                    {isLoading && v2Relationship && <CircularProgress size={20} className={classes.circularProgress} />}
                  </>
                )}
              </Grid>
              <Box width="100%" marginTop="-5px" position="relative" padding="0px 5px">
                {this.state.suggestedUsers.length > 0 && (
                  <Box bgcolor="white" width="100%" maxHeight="200px" overflow="auto" boxShadow={3}>
                    <List>
                      {(v2Relationship ? filterSuggestedUser : this.state.suggestedUsers).map(
                        (user, index) =>
                          user &&
                          user.contactUsername && (
                            <Grow in={true} key={user.contactUsername}>
                              <ListItem onClick={() => this.manageUser(this.MANAGE_TYPE.ADD, user, index)} button>
                                {v2Relationship && (
                                  <>
                                    {user.role === 'Learner' && <this.LearnerMenuItem user={user} index={index} />}
                                    {user.role !== 'Learner' && (
                                      <this.StaffMenuItem classes={classes} user={user} index={index} />
                                    )}
                                  </>
                                )}
                                {!v2Relationship && <ListItemText primary={user.contactUsername} />}
                              </ListItem>
                            </Grow>
                          )
                      )}
                    </List>
                  </Box>
                )}
              </Box>
            </Grid>
          </ClickAwayListener>

          <Divider className={classes.divider} />
          {this.state.selectedUsers.length > 0 && (
            <>
              <Grid container item>
                <Box width="100%" alignItems="center" display="flex" justifyContent="space-between">
                  <Typography className={classes.linkingText}>
                    Linking to {this.state.selectedUsers.length > 0 ? `(${this.state.selectedUsers.length})` : null}:
                  </Typography>
                  {!this.state.isBoxHidden && (
                    <Button onClick={() => this.manageUser(this.MANAGE_TYPE.CLEAR)} color="primary">
                      CLEAR
                    </Button>
                  )}
                </Box>
              </Grid>
              <Grid container item className={classes.chipContainer}>
                {this.state.selectedUsers.length > 0 &&
                  this.state.selectedUsers.map((user, index) => (
                    <Fade in={true}>
                      <Box className={classes.selectedChip}>
                        <Box>
                          <Typography className={classes.chipMainText}>{user.contactName}</Typography>
                          <Typography className={classes.chipSubText}>
                            {user.locationName} {user.docId ? `> DOC ${user.docId}` : null}
                          </Typography>
                        </Box>
                        <Box>
                          <IconButton
                            onClick={() => this.manageUser(this.MANAGE_TYPE.REMOVE, user, index)}
                            className={classes.chipCancelBtn}
                            size="small"
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        </Box>
                      </Box>
                    </Fade>
                  ))}
              </Grid>
            </>
          )}
        </DialogContent>
        <DialogActions
          classes={{
            root: classes.dialogActionRoot,
          }}
        >
          <Button
            onClick={() => {
              this.toggleFlag(false, 'isLinkDialogOpen');
              this.props.onClose();
              this.toggleFlag(true, 'isConfirmOpen');
            }}
            variant="contained"
            color="primary"
            disabled={this.state.selectedUsers.length === 0}
            disableElevation
            className={classes.doneBtn}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  render() {
    return (
      <>
        <Loader isLoading={this.global.isLoading}/>
        <this.LinkingDialog users={this.state.availableRelationps} />
        <ConfirmationModal
          isOpen={this.state.isConfirmOpen}
          onClose={() => this.toggleFlag(false, 'isConfirmOpen')}
          onContinue={() => this.onConfirm()}
          heading={`Link learners to ${this.userRole} account?`}
        />
        <ResponseBox
          heading="Link Learner Confirmation"
          isOpen={this.state.isResponseBoxOpen}
          onClose={() => this.toggleFlag(false, 'isResponseBoxOpen')}
          data={this.state.responseBoxData}
          groupedView={false}
        />
      </>
    );
  }
}

export default withStyles(styles)(withUnleashClient(LinkUser));
